import { render, staticRenderFns } from "./modelList.vue?vue&type=template&id=40db7951&scoped=true&"
import script from "./modelList.vue?vue&type=script&lang=js&"
export * from "./modelList.vue?vue&type=script&lang=js&"
import style0 from "./modelList.vue?vue&type=style&index=0&id=40db7951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db7951",
  null
  
)

export default component.exports